export const baseUrl = "https://jsonplaceholder.typicode.com";
export const BASE_URL_STAGING = "https://api.leeps.trangotechdevs.com/api"
export const BASE_URL_STAGINGHTTP = "http://api.leeps.trangotechdevs.com:3039/api"
export const CHAT_PORTURL = 'http://api.leeps.trangotechdevs.com:3039'
export const INITIAL_TOKEN = "f4ae5389-a941-430c-8836-c25c1886c3c4"
